import React from 'react'
import '../../App.css'
import "./AboutUs.css"
import { AboutTeam } from './AboutTeam'
import { AboutSlider } from './AboutSlider'

export const AboutUs = () => {
  return (
<>
<AboutSlider/>
<AboutTeam/>
</>
  )
}
